export function HtmlBlock({ props }: { props: { code?: string } }) {
  if (!props.code) return null;
  return <div className="w-full" dangerouslySetInnerHTML={{ __html: props.code }} />;
}
